import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/ScienceDepartment.css';

const scienceDepts = [
  {
    name: 'Physics',
    established: 2013,
    intake: 120,
    link: '/departments/physics',
  },
  {
    name: 'Chemistry',
    established: 2013,
    intake: 120,
    link: '/departments/chemistry',
  },
  {
    name: 'Botany',
    established: 2013,
    intake: 120,
    link: '/departments/botany',
  },
  {
    name: 'Zoology',
    established: 2013,
    intake: 120,
    link: '/departments/zoology',
  },
  {
    name: 'Mathematics',
    established: 2013,
    intake: 120,
    link: '/departments/mathematics',
  },
  {
    name: 'Electronics',
    established: 2013,
    intake: 120,
    link: '/departments/electronics',
  },
];

const ScienceDepartment = () => {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setFade(true), 100);
  }, []);

  return (
    <>
      <Navbar />
      <section className='section-wrapper-no-text-align'>
      <div className={`science-container ${fade ? 'fade-in' : ''}`}>
        <section className="science-header">
          <h4>Shri Mulikadevi Mahavidyalaya, Nighoj</h4>
          <h2>Science Faculty & Departments</h2>
          <p>
            The Science Faculty offers B.Sc. degrees in Physics, Chemistry, Botany, Zoology,
            Mathematics, and Electronics. Through innovative teaching, experiments, and activities,
            we prepare students for higher education and careers in science and technology.
          </p>
        </section>

        <section className="dept-cards">
          {scienceDepts.map((dept, i) => (
            <div key={i} className="dept-card animate-card">
              <h3>{dept.name}</h3>
              <p><strong>Established:</strong> {dept.established}</p>
              <p><strong>Intake:</strong> {dept.intake} per year</p>
              <a className="learn-btn" href={dept.link}>Learn More</a>
            </div>
          ))}
        </section>
      </div>
      </section>
      <Footer />
    </>
  );
};

export default ScienceDepartment;
